import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/shared/services/authentication/authentication.service';
import { environment } from 'src/environment/environment';
import * as authUtils from '../auth-utils';
import * as authConsts from '../auth-constants';
import { ToastService } from 'src/app/shared/services/common/toast.service';
import { LoginLoaderService } from 'src/app/shared/services/common/loader.service';
import { SignupService } from '../service/signup.service';
import { AuthConnectService } from '../service/auth-connect.service';
import { TenantService } from 'src/app/shared/services/tenant/tenant.service';
import { countryOption } from 'src/app/shared/utilities/constants';
import { firstValueFrom, take } from 'rxjs';
import { isProfileCompSubmitSession, isProfileCompViewedOnceSessionKey, SignupMethodSessionKey } from '../auth-constants';
import { FeatureFlagService, VerifyEmailService, getCachedTenantData } from '@laasy/common-layout';
import { StorageListenerService } from 'src/app/shared/services/common/storage-listener.service';
@Component({
  selector: 'app-auth-connect',
  templateUrl: './auth-connect.component.html',
  styleUrls: ['./auth-connect.component.scss']
})
export class AuthConnectComponent implements OnInit,AfterViewInit {
  laaSyLogo = '../../assets/images/LaaSyClientLogo.png';

  SSO_val = JSON.parse(JSON.stringify(authConsts.cSSO_val));
  pageConfig: any = { ...authConsts.cPageConfig };
  userProfile = structuredClone(authConsts.userProfile);
  @ViewChild('authForm') signInForm!: NgForm;
  page = 'login';
  screenWidth!: number;
  isMobileView: boolean = false;
  signUpPageCount: number = -1;
  showProgressBar: boolean = false;
  isIdPEnabled = environment.idpEnabled;
  tenantWebsite = 'abc.com';
  queryParams:any = {}

  constructor(
    private readonly route: ActivatedRoute,
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private loginLoader: LoginLoaderService,
    private toastService: ToastService,
    private cd: ChangeDetectorRef,
    private signupService:SignupService,
    private authConnectService:AuthConnectService,
    private tenantService:TenantService,
    private verifyEmailService:VerifyEmailService,
    private featureFlagService:FeatureFlagService,
    private storageListenerService:StorageListenerService,
  ) {}

  ngOnInit(): void {
    this.storageListenerService.storageListener$('SSO_OAUTH_RESPONSE').pipe(take(1)).subscribe((event:any) => {
      this.router.navigateByUrl('/auth/signupredirect')
    });
    this.route.params.subscribe(params => {
      this.verifyEmailService.invalidateVerifyEMailCache();
      this.signupService.setSocialLogin(false)
      this.signupService.setSignUpPageCount(-1)
      this.signupService.setTriggerSubmitObservable(-1)
      this.authConnectService.setPageData (this.pageConfig)
      if (params['page'] == 'forgot') this.openForgotpass();
      else if (params['page'] == 'signup') this.openSignup();
      else if (params['page'] == 'logout') this.router.navigateByUrl('/support/logout');
      else if (params['page'] == 'activate') {
        // Email signup - show success toast after account created
        this.openLogin();
        this.toastService.setToast({...authConsts.success_msg,heading: 'Success',text: authUtils.successMsgDict()})
      }
      else if (params['page'] == 'ssosignup'){
        this.page = 'ssosignup';
        const showSocialLogin = this.SSO_val.length > 0
        if(showSocialLogin)
          this.signupService.setSocialLogin(true)
        else
          this.router.navigateByUrl('/auth/login')
      }
      else if(params['page'] == 'single-sign-on'){
        this.openSingleSignOnSignup();
      }
      else this.openLogin();

      const toastMsg = sessionStorage.getItem(authConsts.toastSessionKey)
      if(toastMsg && (params['page']==='login' || params['page']==='signin')){
        this.toastService.setToast(JSON.parse(toastMsg))
        sessionStorage.removeItem(authConsts.toastSessionKey)
      }
      sessionStorage.removeItem(SignupMethodSessionKey);

      this.route.queryParams.subscribe(params=>{
        this.queryParams = params
      })

      if (['login', 'signin','forgot','signup'].includes(params['page'])) {
        // If the user already has a session, bounce them out before running
        // cleanUserSessionAndCache — its Logout() would otherwise destroy the session.
        this.authService.GetCurrentSession().then(session => {
          if (session !== null) {
            this.router.navigateByUrl('/');
            return;
          }
          this.cleanUserSessionAndCache()
          // queryParams uses distinctUntilChanged so it may not re-emit when navigating
          // between auth pages with identical (or empty) query — re-hydrate authCode from storage
          const storedCode = authUtils.getStoredSignupCode()
          if (storedCode) this.userProfile = { ...this.userProfile, authCode: storedCode }
        })
      }
    });
    this.route.queryParams.subscribe({
      next: ({ email, fname, lname, signupCode }) => {
        const effectiveSignupCode = signupCode || authUtils.getStoredSignupCode() || '';
        if (email) {
          this.userProfile = { ...this.userProfile, email, fname, lname, authCode: effectiveSignupCode };
        }
        if(effectiveSignupCode)
          this.userProfile = { ...this.userProfile, authCode: effectiveSignupCode };
      }
    });
    this.initSignupPageService()
  }

  initSignupPageService(){
    this.signupService.getSignUpPageCountObservable().subscribe(async (count:number)=>{
      this.signUpPageCount = count
      this.authConnectService.setPageData(this.pageConfig)
      const signupPageEnum = this.signupService.getSignupEnum()
      if(count == signupPageEnum?.getting_started || count == signupPageEnum?.subtenant || count == -1){
        const tenantData = await firstValueFrom(this.tenantService.getTenantByDomain())
        this.tenantWebsite = tenantData?.tenantPrivacyPolicyInfo?.websiteUrl
        this.authConnectService.customizationApplied$.next(new Date().getTime())
      }
    })

    this.authConnectService.getPageData().subscribe((data:any)=>{
      this.pageConfig = data
    })
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  isSubTenant(){
    const isSubTenant = this.signupService.isSubTenant()
    return isSubTenant
  }

  scrolltotop() {
    authUtils.scrolltoTop();
  }

  navigate(page: string) {
    const path = page.replace(/\s+/g, '');
    this.router.navigate(['auth', path.toLowerCase()]);
  }

  getContentStyle() {
    return {
      'content-empty': this.pageConfig.heading == '',
      content: this.pageConfig.heading != '' || this.isGettingStartedPage(),
      'content-resetpass': this.pageConfig.heading == authConsts.p_reset_password.heading
    };
  }

  openLogin() {
    const social_provider = environment.aws_cognito_social_providers.map((x: string) =>
      x.toLowerCase()
    );
    this.close_msg();
    this.pageConfig = { ...authConsts.cPageConfig };
    this.SSO_val = JSON.parse(JSON.stringify(authConsts.cSSO_val)).filter((x: any) =>
      social_provider.includes(x.name.toLowerCase())
    );
    this.scrolltotop();
    this.page = 'login';
    this.authConnectService.setPageData (this.pageConfig)

  }

  openSignup() {
    this.userProfile.email = '';
    this.userProfile.pass = '';
    this.close_msg();
    this.pageConfig = {...authUtils.clearpage(this.pageConfig),...authConsts.p_create_account}
    this.pageConfig.buttonText = 'Continue';
    this.scrolltotop();
    this.page = 'signup';
    const social_provider = environment.aws_cognito_social_providers.map((x: string) =>
      x.toLowerCase()
    );
    this.SSO_val = JSON.parse(JSON.stringify(authConsts.cSSO_val)).filter((x: any) =>
      social_provider.includes(x.name.toLowerCase())
    );
    this.cd.detectChanges();
    this.authConnectService.setPageData (this.pageConfig)

  }

  async openSingleSignOnSignup() {
    const user = await this.authService.GetCurrentUser();
    this.userProfile = {
      ...this.userProfile,
      email:user?.attributes?.email ?? user?.signInUserSession?.idToken?.payload?.email,
      fname: user?.attributes?.given_name ?? user?.signInUserSession?.idToken?.payload?.given_name,
      lname: user?.attributes?.family_name ?? user?.signInUserSession?.idToken?.payload?.family_name,
      country: countryOption[0].name,
      phone: user?.attributes?.phone_no ?? user?.signInUserSession?.idToken?.payload?.phone_no
    };
    this.close_msg();
    this.scrolltotop();
    this.page = 'single-sign-on';
    this.cd.detectChanges();
    this.authConnectService.setPageData (this.pageConfig)

  }

  openForgotpass() {
    this.close_msg();
    this.SSO_val = [];
    this.pageConfig = authUtils.clearpage(this.pageConfig);
    this.pageConfig.buttonText = 'Send Verification Code';
    this.pageConfig ={...this.pageConfig,...authConsts.p_forgot_pass}
    this.scrolltotop();
    this.page = 'forgotpass';
    this.authConnectService.setPageData (this.pageConfig)

  }
  updatePageConfig(e: any) {
    if (e == 'forgotpass') this.openForgotpass();
    if (e == 'otp') this.openResetpass();
    if (e == 'updatepass') this.openCretepass();
  }

  openCretepass() {
    this.close_msg();
    this.SSO_val = [];
    this.pageConfig = authUtils.clearpage(this.pageConfig);
    this.pageConfig.heading = 'Create password';
    this.pageConfig.buttonText = 'Continue';
    this.scrolltotop();
    this.page = 'updatepass';
    this.authConnectService.setPageData (this.pageConfig)

  }

  openResetpass() {
    this.close_msg();
    this.SSO_val = [];
    this.pageConfig = authUtils.clearpage(this.pageConfig);
    this.pageConfig.buttonText = 'Continue';
    this.pageConfig ={...this.pageConfig,...authConsts.p_reset_password}
    this.scrolltotop();
    this.page = 'otp';
    this.authConnectService.setPageData (this.pageConfig)

  }

  close_msg() {
    this.toastService.setToast(null);
  }

  async handleAuth(provider: string): Promise<void> {
    if(this.featureFlagService.isIFrame && provider === ''){
      this.authService.iframeSSO('');
      return;
    }

    if(provider === ''){
      try {
        const ssoEntry = JSON.parse(getCachedTenantData()?.homeLayoutCustomization)?.SSO_entry;
        if(ssoEntry){
          this.authService.IdPAuthWithEntry(ssoEntry);
          return;
        }
      } catch (error) {
        
      }
      
      this.authService.IdPAuth();
      return;
    }
    localStorage.setItem('ssoSignupFederatedProvider', provider);
    if (this.page === 'signin' || this.page === 'login') {
      this.loginLoader.showLoginLoader(true);
      this.authService.FederatedAuth(provider);
    } else this.router.navigate(['/auth/ssosignup'],{queryParams:this.queryParams});
  }

  isGettingStartedPage(){
    const isGettingStarted = this.signUpPageCount === this.signupService.getSignupEnum()?.getting_started
    if(isGettingStarted && this.page === 'signup') this.pageConfig.heading = 'Getting Started'
    return isGettingStarted
  }

  isTopImg(){
    return this.page.includes('signup') && this.isGettingStartedPage()
  }

  cleanUserSessionAndCache(){
    localStorage.removeItem('isUserProfileChecked');
    localStorage.removeItem(isProfileCompSubmitSession.key)
    localStorage.removeItem(isProfileCompViewedOnceSessionKey)
    this.userProfile = structuredClone(authConsts.userProfile);
    this.authService.Logout(false,false)
    // TODO: using exported const of web-common-package
    const customizationEndPoint = btoa(`${environment.apiUri}/tenant/api/tenantauth/customizations`)
    localStorage.removeItem(customizationEndPoint)
  }
}
